/* eslint-disable eqeqeq */
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import Box from 'core/ui/Box';
import Grid from 'core/ui/Grid';
import Typography, { fontStyle } from 'core/ui/Typography';
import Radio from 'core/ui/Radio';
import Checkbox from 'core/ui/Checkbox';
import Paper from 'core/ui/Paper';
import TextFieldRounded from 'core/ui/TextFieldRounded';
import { CompetitionContext } from '../index';
import Cost from './Cost';

const SettingOption = ({ setValue, value, label, t }) => (
  <>
    <Typography style={fontStyle.label} variant="body1">
      {label}
    </Typography>
    <Box display="flex">
      <Radio
        label={
          <Typography style={fontStyle.small} variant="caption" color="textSecondary">
            {t(`button.yes`).toUpperCase()}
          </Typography>
        }
        onClick={() => setValue(true)}
        checked={value}
      />
      <Box ml={3}>
        <Radio
          label={
            <Typography style={fontStyle.small} variant="caption" color="textSecondary">
              {t(`button.no`).toUpperCase()}
            </Typography>
          }
          onClick={() => setValue(false)}
          checked={!value}
        />
      </Box>
    </Box>
  </>
);

export default () => {
  const { t } = useTranslation();
  const formContext = useContext(CompetitionContext);

  return (
    <Grid container pb={3}>
      <Grid item xs={12} sm={12} md={12} lg={12}>
        <Box mt={3}>
          <Typography variant="h5" mb={2} color="primary">
            {t('competition.title.settings')}
          </Typography>
        </Box>

        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <Box display="flex" className="gap-10" flexWrap="wrap">
              <Paper p={2}>
                <Typography style={fontStyle.label} variant="body1">
                  {t('competition.label.location').toUpperCase()}
                </Typography>
                <Box display="flex">
                  <Checkbox
                    disabled={formContext.competition.started}
                    label={
                      <Typography style={fontStyle.small} variant="caption" color="textSecondary">
                        {t(`competition.label.location.online`).toUpperCase()}
                      </Typography>
                    }
                    onClick={() => formContext.setValue('online', !formContext.watch('online'))}
                    checked={formContext.watch('online')}
                  />
                  <Box ml={3}>
                    <Checkbox
                      disabled={formContext.competition.started}
                      label={
                        <Typography style={fontStyle.small} variant="caption" color="textSecondary">
                          {t(`competition.label.location.inPerson`).toUpperCase()}
                        </Typography>
                      }
                      onClick={() =>
                        formContext.setValue('inPerson', !formContext.watch('inPerson'))
                      }
                      checked={formContext.watch('inPerson')}
                    />
                  </Box>
                </Box>
              </Paper>

              <Paper p={2}>
                <Typography style={fontStyle.label} variant="body1">
                  {t('competition.label.eventType').toUpperCase()}
                </Typography>
                <Box display="flex">
                  <Radio
                    label={
                      <Typography style={fontStyle.small} variant="caption" color="textSecondary">
                        {t(`competition.label.eventType.individual`).toUpperCase()}
                      </Typography>
                    }
                    onClick={() => formContext.setValue('eventType', 'individual')}
                    checked={
                      formContext.watch('eventType') === 'individual' ||
                      !formContext.watch('eventType')
                    }
                  />
                  <Box ml={3}>
                    <Radio
                      disabled={formContext.competition.started}
                      label={
                        <Typography style={fontStyle.small} variant="caption" color="textSecondary">
                          {t(`competition.label.eventType.team`).toUpperCase()}
                        </Typography>
                      }
                      onClick={() => formContext.setValue('eventType', 'team')}
                      checked={formContext.watch('eventType') === 'team'}
                    />
                  </Box>
                  <Box ml={3}>
                    <Radio
                      disabled={formContext.competition.started}
                      label={
                        <Typography style={fontStyle.small} variant="caption" color="textSecondary">
                          {t(`competition.label.eventType.both`).toUpperCase()}
                        </Typography>
                      }
                      onClick={() => formContext.setValue('eventType', 'both')}
                      checked={formContext.watch('eventType') === 'both'}
                    />
                  </Box>
                </Box>
              </Paper>

              <Paper p={2}>
                <Typography style={fontStyle.label} variant="body1">
                  {t('competition.label.visibility').toUpperCase()}
                </Typography>
                <Box display="flex">
                  <Radio
                    label={
                      <Typography style={fontStyle.small} variant="caption" color="textSecondary">
                        {t(`competition.label.type.public`).toUpperCase()}
                      </Typography>
                    }
                    onClick={() => formContext.setValue('isPrivate', false)}
                    checked={
                      formContext.watch('isPrivate') === false ||
                      formContext.watch('isPrivate') === undefined
                    }
                  />
                  <Box ml={3}>
                    <Radio
                      label={
                        <Typography style={fontStyle.small} variant="caption" color="textSecondary">
                          {t(`competition.label.type.private`).toUpperCase()}
                        </Typography>
                      }
                      onClick={() => formContext.setValue('isPrivate', true)}
                      checked={formContext.watch('isPrivate') === true}
                    />
                  </Box>
                </Box>
              </Paper>

              <Paper p={2}>
                <SettingOption
                  label={t('workout.heats').toUpperCase()}
                  value={formContext.watch('heats')}
                  setValue={(v) => formContext.setValue('heats', v)}
                  t={t}
                />
              </Paper>
              <Paper p={2}>
                <SettingOption
                  label={t('competition.label.hideLeaderboard').toUpperCase()}
                  value={formContext.watch('hideLeaderboard')}
                  setValue={(v) => formContext.setValue('hideLeaderboard', v)}
                  t={t}
                />
              </Paper>
              <Paper p={2}>
                <Typography style={fontStyle.label} variant="body1">
                  {t('competition.label.leaderboardOrder').toUpperCase()}
                </Typography>
                <Box display="flex">
                  <Radio
                    label={
                      <Typography style={fontStyle.small} variant="caption" color="textSecondary">
                        {t(`competition.label.highest`).toUpperCase()}
                      </Typography>
                    }
                    onClick={() => formContext.setValue('leaderboardOrder', 'highest')}
                    checked={formContext.watch('leaderboardOrder') === 'highest'}
                  />
                  <Box ml={3}>
                    <Radio
                      label={
                        <Typography style={fontStyle.small} variant="caption" color="textSecondary">
                          {t(`competition.label.lowest`).toUpperCase()}
                        </Typography>
                      }
                      onClick={() => formContext.setValue('leaderboardOrder', 'lowest')}
                      checked={formContext.watch('leaderboardOrder') === 'lowest'}
                    />
                  </Box>
                </Box>
              </Paper>
            </Box>

            <Box display="flex" className="gap-10" flexWrap="wrap" mt={3}>
              <Box>
                <Paper p={2}>
                  <SettingOption
                    label={t('competition.label.hasDividions').toUpperCase()}
                    value={formContext.watch('hasDivisions')}
                    setValue={(v) => formContext.setValue('hasDivisions', v)}
                    t={t}
                  />
                </Paper>
              </Box>

              {formContext.watch('hasDivisions') && (
                <>
                  <Box>
                    <Paper p={2}>
                      <SettingOption
                        label={t('competition.label.multiDivisionRegistrations').toUpperCase()}
                        value={formContext.watch('multiDivisionRegistrations')}
                        setValue={(v) => formContext.setValue('multiDivisionRegistrations', v)}
                        t={t}
                      />
                    </Paper>
                  </Box>
                  <Box>
                    <Paper p={2}>
                      <SettingOption
                        label={t('competition.label.payPerDivision').toUpperCase()}
                        value={formContext.watch('payPerDivision')}
                        setValue={(v) => formContext.setValue('payPerDivision', v)}
                        t={t}
                      />
                    </Paper>
                  </Box>
                </>
              )}

              {formContext?.watch('online') && (
                <>
                  <Paper p={2}>
                    <Typography style={fontStyle.label} variant="body1">
                      {t('competition.label.releaseVideos').toUpperCase()}
                    </Typography>
                    <Box display="flex">
                      <Radio
                        label={
                          <Typography
                            style={fontStyle.small}
                            variant="caption"
                            color="textSecondary"
                          >
                            {t(`competition.label.releaseVideos.afterEvent`).toUpperCase()}
                          </Typography>
                        }
                        onClick={() => formContext.setValue('releaseVideos', false)}
                        checked={
                          formContext.watch('releaseVideos') === false ||
                          formContext.watch('releaseVideos') === undefined
                        }
                      />
                      <Box ml={3}>
                        <Radio
                          label={
                            <Typography
                              style={fontStyle.small}
                              variant="caption"
                              color="textSecondary"
                            >
                              {t(`competition.label.releaseVideos.immediately`).toUpperCase()}
                            </Typography>
                          }
                          onClick={() => formContext.setValue('releaseVideos', true)}
                          checked={formContext.watch('releaseVideos') === true}
                        />
                      </Box>
                    </Box>
                  </Paper>
                  <Box>
                    <Paper p={2}>
                      <SettingOption
                        label={t('competition.label.rankByVideo').toUpperCase()}
                        value={formContext.watch('rankByVideo')}
                        setValue={(v) => formContext.setValue('rankByVideo', v)}
                        t={t}
                      />
                    </Paper>
                  </Box>
                  <Box>
                    <Paper p={2}>
                      <SettingOption
                        label={t('competition.label.requireVerification').toUpperCase()}
                        value={formContext.watch('requireVerification')}
                        setValue={(v) => formContext.setValue('requireVerification', v)}
                        t={t}
                      />
                    </Paper>
                  </Box>
                  <Box>
                    <Paper p={2}>
                      <SettingOption
                        label={t('competition.label.hideWatch').toUpperCase()}
                        value={formContext.watch('hideWatch')}
                        setValue={(v) => formContext.setValue('hideWatch', v)}
                        t={t}
                      />
                    </Paper>
                  </Box>
                </>
              )}

              <Box>
                <Paper p={2}>
                  <SettingOption
                    label={t('competition.label.hideJudge').toUpperCase()}
                    value={formContext.watch('hideJudge')}
                    setValue={(v) => formContext.setValue('hideJudge', v)}
                    t={t}
                  />
                </Paper>
              </Box>

              <Paper p={2}>
                <TextFieldRounded
                  name="limitRegistrations"
                  type="number"
                  pattern="[0-9]*"
                  error={formContext.errors.limitRegistrations}
                  inputRef={formContext.register()}
                  placeholder={t('competition.label.limitRegistrations')}
                  label={t('competition.label.limitRegistrations').toUpperCase()}
                  bordered
                />
              </Paper>
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <Cost />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
